import { useProperty, useTranslation } from '@eti/providers';
import { breakpoints, Button, Stack } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { forwardRef } from 'react';
import DirectFlight from './DirectFlight';
import ZeroWidthSpace from './ZeroWidthSpace';

const buttonWrapperStyles = css`
  justify-content: space-between;

  @media (min-width: ${breakpoints._768}) {
    flex-direction: column-reverse;
  }
`;

const hiddenStyles = css`
  display: none;
`;

const visibleStyles = css`
  display: block;
`;

const buttonStyles = css`
  width: 100%;

  @media ${mediaQueries.large.up} {
    min-width: 180px;
  }
`;

interface SubmitButtonProps {
  areOriginAndDestinationFilled: boolean;
  isMultiStop: boolean;
  isStopoverEnabled: boolean;
}

const SubmitButton = forwardRef<HTMLAnchorElement, SubmitButtonProps>(
  ({ areOriginAndDestinationFilled, isMultiStop, isStopoverEnabled }, ref) => {
    const { t } = useTranslation();
    const { p } = useProperty();
    const showDirectFlight =
      !p('SearchForm.ShowExtendedForm.Enabled') &&
      !isMultiStop &&
      areOriginAndDestinationFilled &&
      !p('Searchform.Stopover.Enabled');

    const redirectHref: string = p('SearchForm.RedirectHref.Value');
    const isLink = Boolean(p('SearchForm.RedirectHref.Enabled')) && Boolean(redirectHref);

    return (
      <Stack className={!isStopoverEnabled ? buttonWrapperStyles : undefined} spacing={24}>
        {!isStopoverEnabled && (
          <Stack className={showDirectFlight ? visibleStyles : hiddenStyles} spacing={4}>
            <ZeroWidthSpace isDesktopOnly />
            <DirectFlight />
          </Stack>
        )}
        <Stack spacing={4}>
          <ZeroWidthSpace isDesktopOnly />
          <Button
            as={isLink ? 'a' : undefined}
            className={buttonStyles}
            data-testid="searchForm-searchFlights-button"
            href={isLink ? redirectHref : undefined}
            ref={ref}
            type={isLink ? undefined : 'submit'}
            variant="primary"
          >
            {t('Button.Text.Search.Air')}
          </Button>
        </Stack>
      </Stack>
    );
  },
);

export default SubmitButton;
